import React from "react";

const ImportantLinksColumn = () => {
  const importantLinks = [
    { name: "महाराष्ट्र शासन", url: "https://www.maharashtra.gov.in/" },
    { name: "शासन निर्णय: सर्व राज्य शासन विभाग", url: "https://srp.maharashtra.gov.in/" },
    { name: "राज्य शासन निविदा पोर्टल", url: "https://eproc.maharashtra.gov.in/" },
    { name: "जीईएम (सरकारी ई-मार्केटप्लेस)", url: "https://gem.gov.in/" },
    { name: "ग्रामीण विकास मंत्रालय : केंद्र शासन", url: "https://rural.nic.in/" },
    { name: "पंचायत विकास योजना पोर्टल (GPDP)", url: "https://gpdp.maharashtra.gov.in/" },
    { name: "ग्राम मानचित्र पोर्टल", url: "https://grammaportal.maharashtra.gov.in/" },
    { name: "भूमी अभिलेख", url: "https://mahabhulekh.maharashtra.gov.in/" }
  ];

  return (
    <div className="bg-custom-gray p-4 border rounded shadow-sm">
      <h2 className="font-bold text-lg border-b pb-2 mb-2 text-cyan-500">महत्त्वाचे दुवे</h2>
      <ul className="list-disc pl-5 space-y-2 text-gray-700">
        {importantLinks.map((link, idx) => (
          <li key={idx}>
            <a
              href={link.url}
              target="_blank" // नवीन tab मध्ये open करेल
              rel="noopener noreferrer"
              className="hover:text-cyan-600 hover:underline transition"
            >
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ImportantLinksColumn;
